import InvoiceApiClient from "./base";

// Sheets Settings API
export const sheetsSettingsApi = {
  // Get current sheets settings
  getSettings: () => {
    return InvoiceApiClient.get("/sheets/settings");
  },

  // Update sheets settings (partial or complete update)
  updateSettings: (settings) => {
    return InvoiceApiClient.post("/sheets/settings", settings);
  },

  // Reset sheets settings to defaults
  resetSettings: () => {
    return InvoiceApiClient.delete("/sheets/settings");
  },
};
